// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { LayersEnum } from '../Utils/LayersEnum';
export class TerceraChartBaseRenderer {
    get Visible() {
        return this._Visible;
    }
    set Visible(value) {
        this._Visible = value;
    }
    get UseInAutoscale() {
        return this._UseInAutoscale;
    }
    set UseInAutoscale(value) {
        this._UseInAutoscale = value;
    }
    constructor(chart) {
        this.Rectangle = Rectangle.Empty();
        this._Visible = true;
        this._UseInAutoscale = false;
        this.assignLayer = LayersEnum.Main;
        this.ClassNameStorage = {};
        this.chart = chart;
        this.SetClassName('TerceraChartBaseRenderer');
    }
    SetClassName(className) {
        this.ClassNameStorage = {};
        this.ClassNameStorage[className] = true;
    }
    FindMinMax(out_minMax, window) {
        out_minMax.tMin = -Number.MAX_VALUE;
        out_minMax.tMax = Number.MAX_VALUE;
        return false;
    }
    Draw(gr, window, windowsContainer, advParams) { }
    IsNeedDraw(numberOfLayer) {
        return this.assignLayer === numberOfLayer;
    }
    GetAssignLayer() {
        return this.assignLayer;
    }
    IsNeedForceUpdate() {
        return false;
    }
    ProcessMouseMove(e) {
        return false;
    }
    ProcessMouseDown(e) {
        return false;
    }
    ProcessMouseEnter(e) { }
    ProcessMouseUp(e) {
        return false;
    }
    ProcessMouseLeave(e) { }
    ProcessMouseDoubleClick(e) {
        return false;
    }
    ProcessMouseClick(e) {
        return false;
    }
    ProcessMouseWheel(e) {
        return false;
    }
    ProcessMultiTouches(e) {
        return false;
    }
    OnKeyDown(e) { }
    OnKeyUp(e) { }
    Dispose() {
        this.chart = null;
    }
    Properties() {
        return [];
    }
    callBack(properties) { }
    Localize() { }
    ThemeChanged() { }
    GetContextMenu(e, chart) {
        return [];
    }
    GetCursor(e) {
        return null;
    }
    GetTooltip(e) {
        return null;
    }
}
